import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { User, TextBlock } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SharedDataService, SortDirection } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, Subscription, combineLatest } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';
import { TextblockEditComponent } from '../textblock-edit/textblock-edit.component';

@Component({
	selector: 'app-textblock-list',
	templateUrl: './textblock-list.component.html',
	styleUrls: ['./textblock-list.component.scss']
})
export class TextblockListComponent implements OnInit, AfterViewInit, OnDestroy {

	loading: boolean = false;
	rows: TextBlock[];

	advancedSearch: Search = new Search('textblock', `concat(entity,'',name)`, 'textblock');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;

	@Input()
	tenderid: number;

	loggedUser: User;
	subcription: Subscription;

	constructor(
		private demandService: CrudService<TextBlock>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService) {

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('sort');
	}

	ngAfterViewInit() {
		const urlparamsreq = this.listfilters.readParams();

		const requests: Observable<any>[] = [urlparamsreq];

		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
			}
			this.search(data[0]);

		});
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}
	}


	load() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();

		if (this.tenderid) {
			this.advancedSearch.addSimpleFilter('tenderid', this.tenderid);
		}

		const datarequest = this.demandService.searchEntities(TextBlock, 'textblock', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.demandService.countEntities(TextBlock, 'textblock', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	onPageChange(pageInfo: any) {

		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}



	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: TextBlock, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-textblock-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.demandService.deleteEntity(TextBlock, 'textblock', row).subscribe(() => {
					this.translateService.get(['labels.textblock-deleted', 'labels.textblock']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.textblock-deleted'], messages['labels.textblock']);
						this.load();
					});
				});
			}
		});
	}


	edit(id?: number) {
		const modal = this.modalService.open(TextblockEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.tenderid = this.tenderid;

		if (id) {
			modal.componentInstance.load(id);
		}
		modal.result.then((newItem: TextBlock) => {
			this.load();
		}).catch(() => {});
	}

}
